<div *ngIf="displayRedyCard" class="consumptions-card-bar" (click)="open()">
    <div class="container">
        <div class="bar" [ngClass]="{ app: isApp }">
            <i class="icon-consumption-bar"  aria-hidden="true"></i>
            <div class="description" [innerHTML]="cardDescription | translate"></div>
            <button class="app-btn">
                {{ "pt.edp.edponline.card.bar.consumptions.app.button" | translate }}
            </button>
        </div>
    </div>
</div>
